import React from "react";
import Loadable from "../../react-loadable";
import middleware from "../../middleware";
import WeaCustomNew from "../wea-custom-new";

const WeaCollet = Loadable({
  loader: () => import("./public"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

class CustomCollect extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <WeaCustomNew
        ecId={`${this.props.ecId}_WeaCustomNew@1eendk`}
        _uuid="0bd92b22-90f1-4d42-91a4-695adf976bc9"
        type="collectCom"
        {...this.props}
      >
        <WeaCollet
          {...this.props}
          ecId={`${this.props.ecId}_WeaCollet@gjnfz8`}
        />
      </WeaCustomNew>
    );
  }
}

const Com = middleware(CustomCollect, "WeaCollet");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-collect/index.js